import { useQuery } from '@apollo/react-hooks';
import mindfulnessGraph from '../../graphs/mindfulness';

export function useMindfulness() {
	const { loading, error, data } = useQuery(mindfulnessGraph.GET_MINDFULNESSES, {
		fetchPolicy: 'cache-and-network',
	});
	return { loading, data, error };
}
